(function () {
    const $body = $('body');

    var slider = {
        $slider: null,
        options: {},
        vPort: 'always', // default responsive break point
        isMobile: false,
        navText: [
            "<span class='hidden-xs'>prev</span><i class='icon-arrow_l visible-xs'></i>",
            "<span class='hidden-xs'>next</span><i class='icon-arrow_r visible-xs'></i>",
        ],
        ActiveBtnBgColor: '#D6D6D6',
        InactiveBtnBgColor: '#a1a1a1',
        init: function () {
            slider.additionalInit();
            slider.on.build();
            slider.control();
            slider.additionalControls();
            slider.cleanDuplicateID();
        },
        control: function () {
            const playBtn = $('.owl-play');
            const pauseBtn = $('.owl-pause');
            if (config.enableSlideshowControls) { /*eslint-disable-line*/
                $body.on('click', '.owl-play', function () {
                    slider.$slider = $(this).closest('.owl-carousel');
                    slider.$slider.data('owl.carousel').options.autoplay = true;
                    slider.$slider.trigger('refresh.owl.carousel');
                    //slider.$slider.trigger('play.owl.autoplay');
                });
                $body.on('click', '.owl-pause', function () {
                    slider.$slider = $(this).closest('.owl-carousel');
                    slider.$slider.trigger('stop.owl.autoplay');
                });
            }

            $body.on('touchend', '.owl-pause, .owl-play, .owl-prev, .owl-next', function () {
                $(this).css('background', '#d6d6d6');
            });

            $('body').on('touchstart', '.owl-pause, .owl-play, .owl-prev, .owl-next', function () {
                $(this).css('background', '#869791');
            });

            playBtn.on('touchend click', function () {
                $(this).css({background: slider.ActiveBtnBgColor});
                pauseBtn.css({background: slider.InactiveBtnBgColor});
                $('.owl-next').trigger('click');
            });

            pauseBtn.on('touchend click', function () {
                $(this).css({background: slider.ActiveBtnBgColor});
                playBtn.css({background: slider.InactiveBtnBgColor});
            });

            $('.owl-carousel').each(function () {
                var $element = $(this);
                if (typeof $element.closest('.viewport-slider').data('slider-vport') != 'undefined') {
                    slider.vPort = $element.closest('.viewport-slider').data('slider-vport');
                    $(document).on(slider.vPort + '-on', function () {
                        // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                        slider.isMobile = true;
                        slider.get.options($element, true);
                    });
                    $(document).on(slider.vPort + '-off', function () {
                        // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                        slider.isMobile = false;
                        slider.on.destroy($element);
                    });
                }
            });

            if ($('.owl-item:not(.cloned)').first().hasClass('active')) {
                $('.owl-nav .owl-next').addClass('owl-nav-active');
            }
        },
        additionalInit: function () {},
        additionalControls: function () {},
        beforeInitSlider: function ($element) {},
        /**
         * Accessibility for owl carousel
         * @namespace
         */
        accessibility: {
            /**
             * @type Boolean
             * @default false
             * @protected
             */

            /**
             * Setup slider accessibility
             * @param {jQuery} $slider - jQuery object of Owl carousel container .owl-carousel
             * @public
             */
            setup: function ($slider) {
                // make slides accessible
                this.slider($slider);
                if (config.enableSlideshowControls) { /*eslint-disable-line*/
                    // apply meta info to next and previous buttons and make them focusable
                    $slider.find('.owl-prev').attr({
                        role: 'button',
                        title: $slider.data('prev-slide'),
                        'aria-label': $slider.data('prev-slide'),
                        tabindex: '0',
                    });
                    $slider.find('.owl-next').attr({
                        role: 'button',
                        title: $slider.data('next-slide'),
                        'aria-label': $slider.data('next-slide'),
                        tabindex: '0',
                    });
                }
                if (config.enableSlideshowIndicator) { /*eslint-disable-line*/
                    $slider.find('.owl-dot').each(function (index) {
                        var $dot = $(this);
                        $dot.attr({
                            role: 'tab',
                            title: $slider.data('go-to-slide') + ' ' + ($dot.index() + 1),
                            'aria-label': `Slide ${$dot.index() + 1}`,
                            'aria-controls': `carousel-item-${$dot.index() + 1}`,
                            tabindex: '0',
                        });
                    });
                }

                // make root element focusable
                const $root = $slider.find('.owl-stage');
                const $outerRoot = $slider.find('.owl-stage-outer');
                const label = $slider.data('label') || 'Slideshow';
                $root.attr({
                    role: 'list',
                    'aria-label': label, // @todo aria-labeled-by if we have data for it, we don't right now
                    tabindex: '0',
                    'aria-live': 'off',
                });

                slider.accessibility.setSliderReadability($outerRoot, true);

                $slider.find('.owl-item').attr({
                    role: 'listitem',
                });

                const sliderLength = document.querySelectorAll('.owl-item:not(.cloned)')?.length;
                $slider.find('.owl-item:not(.cloned)').each(function (index) {
                    let $item = $(this);
                    $item.attr({
                        'aria-label': `${index + 1} of ${sliderLength}`,
                        id: `carousel-item-${index + 1}`,
                        'aria-roledescription': 'slide',
                    });
                });

                // make root element id and use it for aria controls
                let id = $root.attr('id');
                if (!id) {
                    id = 'slider' + UX.utils.generateId();
                    $root.attr('id', id);
                }

                // make Controls to inform screen readers what they control
                $slider.find('.owl-nav, .owl-controls').attr({
                    role: 'navigation',
                    'aria-label': label,
                });

                $slider.find('.owl-dots').attr({
                    role: 'tablist',
                    'aria-label': 'Slide selection',
                });

                if (config.enableSlideshowControls) { /*eslint-disable-line*/
                    // listen for keyboard input
                    this.keyboardControls($slider, $outerRoot);
                }

                if (config.enableSlideshowAutoplay) { /*eslint-disable-line*/
                    // handle autoplay carousels
                    this.handleAutoplay($slider, $outerRoot);
                }

                if (config.enableSlideshowIndicator) { /*eslint-disable-line*/
                    // make dots accessible
                    this.dots($slider, $outerRoot);
                }

                // make slider accessible by tab key
                this.keyboardTabAccess($slider);

                this.addNavigationHelperText($slider);
            },

            /**
             * Add navigation helper text for screen readers
             * @param {jQuery} $slider - jQuery object of Owl carousel container .owl-carousel
             * @protected
             */
            addNavigationHelperText: function ($slider) {
                if (slider.options.navigationHelper) {
                    const id = `navigation_helper${UX.utils.generateId()}`;
                    $('<span>', {
                        class: 'sr-only',
                        id: id,
                        text: slider.options.navigationHelper,
                    }).insertBefore($slider);
                    $slider.attr({
                        'aria-describedby': id,
                    });
                }
            },

            /**
             * Setup tab key access for slider
             * @param {jQuery} $slider - jQuery object of Owl carousel container .owl-carousel
             * @see inspired by Peppermint.js slider [https://wd.dizaina.net/en/scripts/peppermint/]
             * @protected
             */
            keyboardTabAccess: function ($slider) {
                $slider.find('.owl-item').each(function () {
                    var slide = this;

                    //IE fallback first
                    slide.onfocusin = function () {
                        slider.$slider = $(this).closest('.owl-carousel');
                        const oneOwl = slider.$slider.data('owl.carousel'),
                            stageToReset = slider.$slider.find('.owl-stage-outer')[0],
                            indexOfFocusedSlide = oneOwl.relative($(this).index());

                        //Reset the scroll
                        stageToReset.scrollLeft = 0;
                        //WebKit sets the scroll after the event, we need to reset it with zero timeout.
                        //Keep the first reset to prevent jittering in other browsers
                        setTimeout(function () {
                            stageToReset.scrollLeft = 0;
                        }, 0);

                        if (!$(this).hasClass('active')) {
                            // switch to the slide containing the event if is not visible already
                            // last argument is to enforce "OLD" function for moving in slideshow, necesary for multiple slides displayed in same time
                            // it is not documented anywhere, it comes from built-in plugin src/js/owl.navigation.js from method Navigation.prototype.to ....
                            oneOwl.to(
                                indexOfFocusedSlide,
                                oneOwl.settings.smartSpeed ? oneOwl.settings.smartSpeed : 500,
                                true
                            );
                        }
                    };

                    //Now use the function bound to `onfocusin` in a regular `addEventListener`
                    if (slide.addEventListener) slide.addEventListener('focus', slide.onfocusin, true); //`true` turns on the capturing
                });
            },

            /**
             * Make controls accessible
             * @param $slider
             * @public
             */
            controls: function ($slider, $outerRoot) {
                $slider
                    .find('.owl-play')
                    .attr({
                        role: 'button',
                        title: $slider.data('play-slide'),
                        'aria-label': $slider.data('play-slide'),
                        tabindex: '0',
                    })
                    .on('click', function () {
                        $slider.removeAttr('data-pause');
                        slider.accessibility.setSliderReadability($outerRoot, false);
                    });
                $slider
                    .find('.owl-pause')
                    .attr({
                        role: 'button',
                        title: $slider.data('pause-slide'),
                        'aria-label': $slider.data('pause-slide'),
                        tabindex: '0',
                    })
                    .on('click', function () {
                        $slider.attr({'data-pause': 'true'});
                    });
            },

            /**
             * Set attributes for slider based on active slide
             * This is only wrapper function to avoid necessity of finding slides in function call
             * @param {jQuery} $slider - jQuery object of Owl carousel container .owl-carousel
             * @public
             */
            slider: function ($slider) {
                this.slides($slider.find('.owl-item'));
            },

            /**
             * Set attributes for slides based on active slide and cloned slides
             * This is the main logic for handling accessibility visibility to be correctly read by screen readers, etc.
             * @param {jQuery} $slides - jQuery collection of slides
             * @public
             */
            slides: function ($slides) {
                // hide all
                this.slide($slides, 'hide');
                // disable cloned items to skip duplicate slides
                this.slide($slides.filter(':not(.active)'), 'disable');
                // enable clone in case it becomes active
                this.slide($slides.filter('.active'), 'enable');
                // show active
                this.slide($slides.filter('.active'));
            },

            setSliderReadability: function ($outerRoot, status) {
                $outerRoot.attr({
                    'aria-live': status ? 'polite' : 'off',
                });
            },

            /**
             * Handle one slide - mixed methods
             * @param {jQuery} $slide - collections of slides or one slide
             * @param {('show'|'hide'|'enable'|'disable')} [action] - available methods
             * @public
             */
            slide: function ($slide, action) {
                var actions = {
                    /**
                     * let screen readers know an item is active
                     * set aria visible on active slide
                     * @param {jQuery} $slide - collections of slides or one slide
                     * @private
                     */
                    show: function ($slide) {
                        $slide.attr('aria-current', 'true');
                        $slide.attr('aria-hidden', 'false');
                    },
                    /**
                     * set aria hidden on all slides
                     * @param {jQuery} $slide - collections of slides or one slide
                     * @private
                     */
                    hide: function ($slide) {
                        $slide.attr('aria-current', 'false');
                        $slide.attr('aria-hidden', 'true');
                    },
                    /**
                     * enable tab index on in case it becomes active
                     * @param {jQuery} $slide - collections of slides or one slide
                     * @private
                     */
                    enable: function ($slide) {
                        $slide.find('[data-was-tabbable]').removeAttr('tabindex').removeAttr('data-was-tabbable');
                    },
                    /**
                     * disable tab index on items to skip duplicate slides in tab order
                     * @param {jQuery} $slide - collections of slides or one slide
                     * @private
                     */
                    disable: function ($slide) {
                        $slide.find(':tabbable').attr('data-was-tabbable', true).attr('tabindex', '-1');
                    },
                };

                // actions logic
                if (typeof action === 'string') {
                    if (typeof actions[action] === 'undefined') {
                        throw new TypeError('No method named "' + action + '" found.');
                    }
                    actions[action]($slide);
                } else if (actions.show) {
                    // default action
                    actions.show($slide);
                }
            },
        },
        get: {
            options: function ($element, pass) {
                slider.$slider = $element;
                slider.speed = slider.$slider.data('speed');
                slider.autoplay = slider.$slider.data('autoplay');
                slider.animation = slider.$slider.data('animation');
                slider.autoWidth = slider.set.autoWidth();
                if (slider.animation === 'fade') {
                    slider.animation = 'fadeOut';
                } else if (slider.animation === 'slide') {
                    slider.animation = '';
                } else if (slider.animation === 'none') {
                    slider.animation = 'fadeOut';
                    slider.speed = 0;
                }
                slider.items = slider.$slider.data('items');
                slider.stagePadding = slider.$slider.data('stagepadding');
                slider.set.responsive();
                slider.indicators = slider.$slider.data('indicators');
                slider.arrow = slider.$slider.data('arrow');
                slider.controls = slider.$slider.data('controls');
                slider.autoHeight = slider.set.autoHeight();
                slider.dotsEach =
                    slider.$slider.data('dotseach') !== undefined ? slider.$slider.data('dotseach') : false;
                slider.lazyLoad = slider.$slider.closest('.lazyLoad-slides').length ? true : false;
                slider.center = slider.set.center();
                slider.margin = slider.set.margin();
                slider.transitionDuration = slider.set.transitionDuration();
                slider.linked = slider.set.linked();
                slider.navigationHelper = slider.$slider.data('navigationHelper');

                UX.slider.loop = UX.slider.$slider.data('loop');
                UX.slider.slideBy = UX.slider.$slider.data('slideby');

                slider.options = {
                    rtl: UX.utils.isRTL(),
                    center: slider.center,
                    stagePadding: slider.stagePadding,
                    loop: UX.slider.loop,
                    items: slider.items,
                    responsive: slider.responsive,
                    autoplay: slider.autoplay,
                    autoWidth: slider.autoWidth,
                    animateOut: slider.animation,
                    dots: slider.indicators,
                    nav: slider.arrow,
                    dotsEach: slider.dotsEach,
                    slideBy: UX.slider.slideBy,
                    autoHeight: slider.autoHeight,
                    autoplayTimeout: slider.speed,
                    autoplayHoverPause: slider.autoplay,
                    navText: slider.navText,
                    lazyLoad: slider.lazyLoad,
                    margin: slider.margin,
                    smartSpeed: slider.transitionDuration,
                    linked: slider.linked,
                    navigationHelper: slider.navigationHelper,
                    onInitialize: function (event) {
                        slider.on.sliderBeforeInit($(event.target));
                    },
                    onInitialized: function (event) {
                        // allow slider accessibility
                        slider.accessibility.setup(slider.$slider);

                        slider.$slider.find('.owl-item.active').first().addClass('first');

                        // set slides height to be equal
                        slider.set.slidesHeight();
                        slider.on.sliderInit($(event.target));
                    },
                    onLoadedLazy: function () {
                        var onLoadedLazy = false;

                        if (!onLoadedLazy) {
                            slider.$slider.trigger('refresh.owl.carousel');
                            onLoadedLazy = true;
                        }
                    },
                };

                slider.on.activate(slider.$slider, pass);

                if (slider.controls && config.enableSlideshowControls) { /*eslint-disable-line*/
                    slider.on.buildControls(slider.$slider);
                }
            },
            responsiveData: function () {
                if (slider.$slider.data('responsive')) {
                    return slider.$slider.data('responsive');
                } else {
                    const responsiveData = slider.$slider.closest('.responsive-slider').data('responsive');
                    if (responsiveData) {
                        return responsiveData;
                    }
                }
                return null;
            },
        },
        set: {
            responsive: function () {
                slider.responsive = slider.get.responsiveData();
                if (slider.responsive) {
                    for (let key in slider.responsive) {
                        switch (key) {
                            case 'xsMin':
                                slider.responsive[0] = slider.responsive[key];
                                break;
                            case 'smMin':
                                slider.responsive[UX.grid.screenXs] = slider.responsive[key];
                                break;
                            case 'mdMin':
                                slider.responsive[UX.grid.screenSm] = slider.responsive[key];
                                break;
                            case 'lgMin':
                                slider.responsive[UX.grid.screenMd] = slider.responsive[key];
                                break;
                            case 'xlgMin':
                                slider.responsive[UX.grid.screenLg] = slider.responsive[key];
                                break;
                            case 'xxlgMin':
                                slider.responsive[UX.grid.screenXlg] = slider.responsive[key];
                                break;
                        }
                    }
                }
            },
            autoHeight: function () {
                var autoHeight = slider.$slider.closest('.autoheight-slider').data('autoheight');
                if (autoHeight !== undefined) {
                    return autoHeight;
                } else {
                    return true;
                }
            },
            autoWidth: function () {
                return false;
            },
            center: function () {
                // if there is wrapper class 'center-slider' then set slider to be center
                return slider.$slider.closest('.center-slider').length > 0;
            },
            margin: function () {
                return 0;
            },
            linked: function () {
                return 0;
            },
            transitionDuration: function () {
                return 250;
            },
            slidesHeight: function () {
                if (slider.$slider.closest('.equal-height-slides').length) {
                    //make all slide same height if slide container contains ".equal-height-slides" class
                    const sliderHeight = slider.$slider.height();
                    if (sliderHeight > 0) {
                        slider.$slider.find('.owl-item', '.slide-item').css('height', slider.$slider.height());
                        slider.$slider.find('.slide-item').css('height', '100%');
                    }
                }
            },
        },
        on: {
            destroy: function ($element) {
                if (slider.vPort.length > 0) {
                    $element.each(function () {
                        if (!$(this).hasClass('slide-removal')) {
                            $(this).addClass('slide-removal').trigger('destroy.owl.carousel');
                            $(this).find('.owl-stage-outer').children(':eq(0)').unwrap();
                        }
                    });
                }
            },
            activate: function ($element, pass) {
                slider.beforeInitSlider($element);

                if (pass || slider.vPort === 'always') {
                    $element.owlCarousel(slider.options);
                    if ($element.hasClass('slide-removal')) {
                        $element.removeClass('slide-removal');
                    }
                } else {
                    if (!$element.hasClass('slide-removal')) {
                        $element.addClass('slide-removal');
                    }
                }
            },
            build: function () {
                $('.owl-carousel').each(function (index) {
                    if (typeof $(this).closest('.viewport-slider').data('slider-vport') != 'undefined') {
                        slider.vPort = $(this).closest('.viewport-slider').data('slider-vport');
                    } else {
                        slider.vPort = 'always';
                    }
                    slider.get.options($(this), false);

                    $(this).on('changed.owl.carousel', function (e) {
                        slider.on.changedSlide($(this), e);
                    });

                    $(this).on('translated.owl.carousel', function (e) {
                        slider.on.translated($(this));
                    });
                });
            },
            translated: function ($slider) {
                $slider.find('.owl-item').removeClass('first');
                $slider.find('.owl-item.active').first().addClass('first');
            },
            changedSlide: function ($slider, e) {
                if ($slider.find('.owl-item:not(.cloned)').last().hasClass('active')) {
                    $slider.find('.owl-nav .owl-next').addClass('owl-nav-active');
                    $slider.find('.owl-nav .owl-prev').removeClass('owl-nav-active');
                } else if ($('.owl-item:not(.cloned)').first().hasClass('active')) {
                    $slider.find('.owl-nav .owl-prev').addClass('owl-nav-active');
                    $slider.find('.owl-nav .owl-next').removeClass('owl-nav-active');
                }
            },
            rebuild: {
                responsive: function () {},
            },
            sliderInit: function ($slider) {},
            sliderBeforeInit: function ($slider) {},
        },

        cleanDuplicateID: function () {
            const clonedSlides = $('.owl-item.cloned');
            clonedSlides.each(function () {
                $(this)
                    .find('[id]')
                    .each(function () {
                        const id = $(this).attr('id');
                        if (id !== '') {
                            $(this).attr('id', id + '-cloned');
                        }
                    });
            });
        },
    };

    if (config.enableSlideshowControls) { /*eslint-disable-line*/
        /**
         * Setup keyboard navigation for slider
         * @param {jQuery} $slider - jQuery object of Owl carousel container .owl-carousel
         * @param {jQuery} $outerRoot - jQuery object of Owl carousel .owl-stage-outer
         * @protected
         */
        slider.accessibility.keyboardControls = function ($slider, $outerRoot) {
            // Briefly hide navigation from screen readers when using left and right arrows to make it only read the content
            const hideNavigationFromReaders = navEl => {
                navEl.attr('aria-hidden', 'true').focus();
                setTimeout(() => {
                    navEl.attr('aria-hidden', 'false');
                }, 500);
            };
            $slider.on('keydown', function (e) {
                slider.$slider = $(this);

                const $focusedElement = $(document.activeElement);
                let type = null;
                switch (e.which) {
                    case 39:
                        type = 'next';
                        break;
                    case 37:
                        type = 'prev';
                        break;
                    case 13:
                        type = 'enter';
                        break;
                }

                // use left and right arrow keys to navigate
                if (type === 'next') {
                    slider.$slider.trigger('next.owl.carousel');
                    hideNavigationFromReaders($slider.find('.owl-next'));
                } else if (type === 'prev') {
                    slider.$slider.trigger('prev.owl.carousel');
                    hideNavigationFromReaders($slider.find('.owl-prev'));
                } else if (type === 'enter') {
                    // if the prev and next buttons are focused, catch "Enter" and navigate in the right direction

                    if ($focusedElement.hasClass('owl-next')) {
                        e.preventDefault();
                        slider.$slider.trigger('next.owl.carousel');
                    } else if ($focusedElement.hasClass('owl-prev')) {
                        e.preventDefault();
                        slider.$slider.trigger('prev.owl.carousel');
                    } else if (
                        $focusedElement.hasClass('owl-dot') ||
                        $focusedElement.hasClass('owl-play') ||
                        $focusedElement.hasClass('owl-pause')
                    ) {
                        $focusedElement.trigger('click');
                    }
                }
            });

            $slider.on('translate.owl.carousel', function (event) {
                $outerRoot.attr({
                    'aria-busy': true,
                });
            });

            $slider.on('translated.owl.carousel', function (event) {
                $outerRoot.attr({
                    'aria-busy': false,
                });

                slider.accessibility.slider($slider);
            });
        };

        slider.on.buildControls = function (elem) {
            const $owlContainer = elem.find('.owl-stage-outer');
            if (elem.find('.owl-controls').length === 0) {
                $owlContainer.after(
                    '<div class="owl-controls"><div class="owl-play">Play</div><div class="owl-pause">Pause</div></div>'
                );
            }
            slider.accessibility.controls(elem, $owlContainer);
        };
    }

    if (config.enableSlideshowAutoplay) { /*eslint-disable-line*/
        /**
         * Pause on focus if auto-play is enabled
         * @see aria-live documentation
         * @param {jQuery} $slider
         */
        slider.accessibility.handleAutoplay = function ($slider, $outerRoot) {
            var autoplay = $slider.data('autoplay');
            if (autoplay) {
                slider.accessibility.setSliderReadability($outerRoot, false);
            }

            $slider
                .bind('focusin', function (event) {
                    slider.accessibility.setSliderReadability($outerRoot, true);
                    $(this).trigger('stop.owl.autoplay');
                })
                .bind('focusout', function () {
                    if (!$slider.data('pause') && autoplay) {
                        $(this).trigger('play.owl.autoplay');
                    }
                    slider.accessibility.setSliderReadability($outerRoot, false);
                });
        };
    }

    if (config.enableSlideshowIndicator) { /*eslint-disable-line*/
        /**
         * Make dots navigation accessible
         * @param $slider
         */
        slider.accessibility.dots = function ($slider, $outerRoot) {
            $slider.find('.owl-dot').on('click', function () {
                /**
                 * Solution for outlines here:
                 *
                 * Blur this, while we don't want to outline to be visible in this case
                 * but we want to see outline when user cycle through page by tab key
                 *
                 * solution combined with CSS rule - to don't display outline, when mouse button is pressed
                 *  .owl-dot:active:focus {
                 *      outline: none;
                 *  }
                 *
                 */

                $(this).blur();
                $(this).trigger('stop.owl.autoplay');
                slider.accessibility.setSliderReadability($outerRoot, true);
            });
        };
    }
    UX.slider = slider; // add to global namespace

    /* if (window.PB && window.PB.$) {
     // make this module reinitialized in pageBuilder mode
     window.PB.$(document.documentElement).on("WidgetReinit.slider", slider.init);
     }*/
})();
